//import Login from '../views/Login'
//import Logout from '../views/Logout'
import page404 from '../components/pages/page404'

// *** PAGES
import login from '../components/pages/login'
import home from '../components/pages/home'
import register from '../components/pages/auth/register'
import logout from '../components/pages/auth/logout'

// *** SHOP PRODUCT
import itemsList from '../components/pages/data/list-items'
import dataProduct from '../components/shop/product/data'

// *** SHOP PRODUCT SELL COMPANY


// *** SHOP BRANDS
// import shopBrands from '../components/shop/brands/index'
import dataShopBrands from '../components/shop/brands/data'
import dataShopCategory from '../components/shop/category/data'


// *** SHOP MODULE cloth
// import dataShopModule from '../components/shop/module/data'

import dataSoftModule from '../components/soft/module/sofa/data'


import dataSoftMaterialGroup from '../components/soft/materialGroup/data'

// import shopParentCloth from '../components/shop/cloth/parentIndex'
import dataSoftMaterial from '../components/soft/material/data'

import moduleSofaOption from '../components/soft/option/data'

import moduleSofaQuality from '../components/soft/quality/data'

import moduleSoftTaxileCare from '../components/soft/taxileCare/data'

import moduleSofaType from '../components/soft/type/data'

import dataSoftElementGroup from '../components/soft/elementGroup/data'

import dataSoftElement from '../components/soft/element/data'


// *** ALL FILES SERVER

import files from '../components/system/files/index'
import dataFiles from '../components/system/files/data'

// *** SYSTEM MODULS

import moduleSlider from '../components/system/web_modules/slider/index'
import dataModuleSlider from '../components/system/web_modules/slider/data'

import listNotification from '../components/layouts/tables/Notification'


import systemExport from '../components/system/export'



export const routes = [
  

   // ***************  SHOP PRODUCTS ************
   
    {
      path: '/shop/product/create',
      name: 'shop-product-create',
      component: dataProduct,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/shop/product/edit/:id',
      name: 'shop-product-edit',
      component: dataProduct,
      meta: {
        requiresAuth: true,
      }

    },

     {
      path: '/shop/product/:page?',
      name: 'shop-product',
      component: itemsList,
      meta: {
        requiresAuth: true,
      }

    },

    // ***************  SHOP PRODUCTS ************
    {
      path: '/shop/product/:page?',
      name: 'shop-product',
      component: itemsList,
      meta: {
        requiresAuth: true,
      }

    },
    {
      path: '/shop/product/create',
      name: 'shop-product-create',
      component: dataProduct,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/shop/product/edit/:id',
      name: 'shop-product-edit',
      component: dataProduct,
      meta: {
        requiresAuth: true,
      }

    },

     {
      path: '/soft/module/product/:id?',
      name: 'soft-module-product',
      component: itemsList,
      meta: {
        requiresAuth: true,
      }

    },



   

   



    // *************** SHOP BRANDS ************

    {
      path: '/shop/brands',
      name: 'shop-brand',
      component: itemsList,
      meta: {
        requiresAuth: true,
      }

    },
    {
      path: '/shop/brand/create',
      name: 'shop-brand-create',
      component: dataShopBrands,
      meta: {
        requiresAuth: true,
      }

    },
    {
      path: '/shop/brand/edit/:id',
      name: 'shop-brand-edit',
      component: dataShopBrands,
      meta: {
        requiresAuth: true,
      }

    },

    // *************** SHOP BRANDS ************

    {
      path: '/shop/category',
      name: 'shop-category',
      component: itemsList,
      meta: {
        requiresAuth: true,
      }

    },
    {
      path: '/shop/category/create',
      name: 'shop-category-create',
      component: dataShopCategory,
      meta: {
        requiresAuth: true,
      }

    },
    {
      path: '/shop/category/edit/:id',
      name: 'shop-category-edit',
      component: dataShopCategory,
      meta: {
        requiresAuth: true,
      }

    },


    // *************** SHOP CLOTH CATEGORY ************

        {
          path: '/soft/material',
          name: 'soft-material',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }

        },

        {
          path: '/soft/material/parent/:id',
          name: 'soft-material-parent',
          component: itemsList,
          meta: {
            requiresAuth: true,
          },

        },

        {
          path: '/soft/material/create',
          name: 'soft-material-create',
          component: dataSoftMaterial,
          meta: {
            requiresAuth: true,
          }

        },

        
        {
          path: '/soft/material/edit/:id',
          name: 'soft-material-edit',
          component: dataSoftMaterial,
          meta: {
            requiresAuth: true,
          }

        },


        // *************** MODULE CLOTH CATEGORY ************

        {
          path: '/soft/material/group',
          name: 'soft-material-group',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }

        },

        {
          path: '/soft/material/group/create',
          name: 'soft-material-group-create',
          component: dataSoftMaterialGroup,
          meta: {
            requiresAuth: true,
          }

        },
        
        {
          path: '/soft/material/group/edit/:id',
          name: 'soft-material-group-edit',
          component: dataSoftMaterialGroup,
          meta: {
            requiresAuth: true,
          }

        },

        // *************** MODULE SOFA ************
        {
          path: '/soft/module',
          name: 'soft-module',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }
        },

         {
          path: '/soft/module/product/:id',
          name: 'soft-module',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }
        },

        {
          path: '/soft/module/create',
          name: 'soft-module-create',
          component: dataSoftModule,
          meta: {
            requiresAuth: true,
          }

        },
        {
          path: '/soft/module/edit/:id',
          name: 'soft-module-edit',
          component: dataSoftModule,
          meta: {
            requiresAuth: true,
          }

        },

         // *************** MODULE SOFA OPTION ************
        {
          path: '/soft/option',
          name: 'soft-option',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }
        },

       

        {
          path: '/soft/option/option/create',
          name: 'soft-option-create',
          component: moduleSofaOption,
          meta: {
            requiresAuth: true,
          }

        },
        {
          path: '/soft/option/option/edit/:id',
          name: 'soft-option-edit',
          component: moduleSofaOption,
          meta: {
            requiresAuth: true,
          }

        },


         // *************** MODULE SOFA QUALITY ************
        {
          path: '/soft/quality',
          name: 'soft-quality',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }
        },

       

        {
          path: '/soft/quality/create',
          name: 'soft-quality-create',
          component: moduleSofaQuality,
          meta: {
            requiresAuth: true,
          }

        },
        {
          path: '/soft/quality/edit/:id',
          name: 'soft-quality-edit',
          component: moduleSofaQuality,
          meta: {
            requiresAuth: true,
          }

        },


          // *************** MODULE TAXILE CARE ************
        {
          path: '/soft/taxtile/care',
          name: 'soft-textile-care',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }
        },

       

        {
          path: '/soft/taxile/care/create',
          name: 'soft-textile-care-create',
          component: moduleSoftTaxileCare,
          meta: {
            requiresAuth: true,
          }

        },
        {
          path: '/soft/taxile/care/edit/:id',
          name: 'soft-textile-care-edit',
          component: moduleSoftTaxileCare,
          meta: {
            requiresAuth: true,
          }

        },



        

         // *************** MODULE SOFA TYPE ************
        {
          path: '/soft/type',
          name: 'soft-type',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }
        },

       

        {
          path: '/soft/type/create',
          name: 'soft-type-create',
          component: moduleSofaType,
          meta: {
            requiresAuth: true,
          }

        },
        {
          path: '/soft/type/edit/:id',
          name: 'soft-type-edit',
          component: moduleSofaType,
          meta: {
            requiresAuth: true,
          }

        },

        // *************** MODULE ADDITIONAL ELEMENT ************

        {
          path: '/soft/element/group',
          name: 'soft-element-group',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }

        },

        {
          path: '/soft/element/group/create',
          name: 'soft-element-group-create',
          component: dataSoftElementGroup,
          meta: {
            requiresAuth: true,
          }

        },

        
        {
          path: '/soft/element/group/edit/:id',
          name: 'soft-element-group-edit',
          component: dataSoftElementGroup,
          meta: {
            requiresAuth: true,
          }

        },

         // *************** MODULE ADDITIONAL ELEMENT ************

       

        {
          path: '/soft/element/create',
          name: 'soft-element-create',
          component: dataSoftElement,
          meta: {
            requiresAuth: true,
          }

        },

        
        {
          path: '/soft/element/edit/:id',
          name: 'soft-element-edit',
          component: dataSoftElement,
          meta: {
            requiresAuth: true,
          }

        },

         {
          path: '/soft/element',
          name: 'soft-element',
          component: itemsList,
          meta: {
            requiresAuth: true,
          }

        },


      // *************** SYSTEM FILES ************

      {
        path: '/files',
        name: 'system-files',
        component: files,
        meta: {
          requiresAuth: true,
        }

      },

      {
        path: '/files/pdf',
        name: 'system-files-pdf',
        component: itemsList,
        meta: {
          requiresAuth: true,
        }
      },

      {
        path: '/files/video',
        name: 'system-files-video',
        component: itemsList,
        meta: {
          requiresAuth: true,
        }

      },
      {
        path: '/files/create/pdf',
        name: 'system-files-create-pdf',
        component: dataFiles,
        meta: {
          requiresAuth: true,
        }

      },
      {
        path: '/files/create/video',
        name: 'system-files-create-video',
        component: dataFiles,
        meta: {
          requiresAuth: true,
        }

      },

      {
        path: '/files/edit/video/:id?',
        name: 'system-files-edit-video',
        component: dataFiles,
        meta: {
          requiresAuth: true,
        }

      },

      {
        path: '/files/edit/pdf/:id',
        name: 'system-files-edit-pdf',
        component: dataFiles,
        meta: {
          requiresAuth: true,
        }
      },


      // ***************  SYSTEM ************
      {
        path: '/notifications',
        name: 'system-notification',
        component: listNotification,
        meta: {
          requiresAuth: true,
        }

      },
      {
        path: '/users/:param1?',
        name: 'users',
        component: itemsList,
        meta: {
          requiresAuth: true,
        }

      },

       {
        path: '/system/export',
        name: 'system-export',
        component: systemExport,
        meta: {
          requiresAuth: true,
        }

      },

      




        // *************** ALL PAGES ************


    // * AUTH

    {
      path: '/',
      name: 'login',
      component: login,
      meta: {
        requiresVisitor: true,
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        requiresVisitor: true,
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout,

    },
    
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        requiresAuth: true,
      }

    },

    {
      path: '/404',
      name: '404',
      component: page404,
    },

    { 
      path: '*',
      name: '404',
      redirect: '/404' 
    }





    ]


// WEBPACK FOOTER //
// ./src/router/routes.js